import React from "react";
import FirstSection from "./FirstSection";
import Dimensions from "./Dimensions";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { generateInSet } from "../../../shared/constants";
import { useTranslation } from "react-i18next";
const SetItem = () => {
  const { i18n } = useTranslation();
  const { model } = useParams();
  const [params, setParams] = React.useState(generateInSet()[model]);
  React.useEffect(() => {
    window.scrollTo(0, 0);
    setParams(generateInSet()[model]);
  }, [i18n.language]);
  return (
    <>
      <Helmet>
      <title>Tramptec - {params.title} | {params.model}</title>
      </Helmet>
      <section className="squirlceItem--container">
        <FirstSection params={params} />
        <Dimensions params={params} />
        {/* <InstallTypes /> */}
      </section>
    </>
  );
};

export default SetItem;
